var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.asset
    ? _c(
        "section",
        {
          staticClass: "d-flex",
          class: _vm.getClasses(),
          attrs: { id: "asset" },
        },
        [
          _vm.asset.player && _vm.asset.player.src
            ? _c("OnDemand")
            : [1, 4].includes(_vm.asset.broadcasting) ||
              _vm.$route.name === "preview"
            ? _c("Live")
            : [2, 3].includes(_vm.asset.broadcasting)
            ? _c("PostLive")
            : _c("PreLive"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }